// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"497eb078","149":"89776325","156":"446d733e","200":"5753668f","243":"f477428f","658":"126da1ca","721":"54d48088"}[chunkId] + ".chunk.js";
};